// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__cQEUq","show":"style_show__Q7mEd","overlay":"style_overlay__4MSaE"};